import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: config.apiGatewayUrl,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const lineOfficialNotificationApi = {
  getLineOfficialNotificationList: (request) => {
    const { params } = request
    const { page_id } = params
    return instance().get(`lon/${page_id}/cms/broadcast`, { params })
  },
  createLineOfficialNotificationBroadcast: (request) => {
    const { data } = request
    const { page_id } = data
    return instance().post(`lon/${page_id}/cms/broadcast`, data)
  },
  editLineOfficialNotificationBroadcast: (request) => {
    const { data } = request
    const { page_id } = data
    return instance().put(`lon/${page_id}/cms/broadcast`, data)
  },
  patchLineOfficialNotificationBroadcast: (request) => {
    const { data } = request
    const { page_id, id } = data
    return instance().patch(`lon/${page_id}/cms/broadcast/${id}`, data)
  },
  deleteLineOfficialNotificationBroadcast: (request) => {
    const { data } = request
    const { page_id, id } = data
    return instance().delete(`lon/${page_id}/cms/broadcast/${id}`, {
      data
    })
  },
  getLogLineOfficialNotificationBroadcastLogs: (request) => {
    const { params } = request
    const { page_id, id } = params
    return instance().get(`lon/${page_id}/cms/broadcast/${id}/logs-v2`, {
      params
    })
  },
  getLogLineOfficialNotificationBroadcast: (request) => {
    const { params } = request
    const { page_id, id } = params
    return instance().get(`lon/${page_id}/cms/broadcast/${id}`, {
      params
    })
  }
}
export default lineOfficialNotificationApi



// WEBPACK FOOTER //
// ./src/api/line-official-notification.js